import { Capacitor } from '@capacitor/core';

export async function ensureCallPermissions() {
  if (!Capacitor.isNativePlatform?.()) return;
  try {
    if (navigator.permissions?.query) {
      await navigator.permissions.query({ name: 'camera' }).catch(() => {});
      await navigator.permissions.query({ name: 'microphone' }).catch(() => {});
    }
  } catch (error) {
    // WebView will prompt via MainActivity / Info.plist
  }
}
